import { isElementInViewport } from '@theme/utilities';

const CHAT_OFFSET_STYLE_ID = 'aac-chat-sticky-offset';

// Section a partir de laquelle la fleche "retour en haut" apparait.
// On cible le suffixe de l'id de section : il reste stable meme si l'id de
// template change (l'id complet ressemble a "shopify-section-template--123__aac_pdp_solidite").
const BACK_TO_TOP_TRIGGER_SELECTOR = '[id$="aac_pdp_solidite"]';

// Quand le bandeau "Ajouter au panier" collant est visible :
//  - on remonte la fleche "retour en haut" et le widget de chat (Shopify Inbox)
//    au-dessus du bandeau, avec un ecart confortable, tout en les gardant alignes.
// Le chat est l'element <shopify-chat> (shadow DOM) ; sa hauteur est pilotee par la
// variable CSS inline --shopify-agent-activator-offset, qu'on surcharge avec !important.
// Le -9px compense le decalage interne du widget pour aligner le bas du bouton chat
// sur celui de la fleche.
function ensureChatOffsetStyle() {
  if (document.getElementById(CHAT_OFFSET_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = CHAT_OFFSET_STYLE_ID;
  style.textContent =
    '.sticky-add-to-cart[data-active="true"] .sticky-back-to-top{bottom:calc(var(--inputs-min-height, 48px) + (2 * var(--padding-sm)) + 27px) !important;}' +
    'body.sticky-atc-on shopify-chat{--shopify-agent-activator-offset:calc(var(--inputs-min-height, 48px) + (2 * var(--padding-sm)) + 27px - 9px) !important;}' +
    // La fleche reste masquee tant que la section solidite n'est pas atteinte,
    // meme si le bandeau sticky est deja actif. On surcharge le display:flex de base.
    '.sticky-back-to-top[data-revealed="false"]{display:none !important;}' +
    '@media (min-width:751px){' +
    '.sticky-add-to-cart[data-active="true"] .sticky-back-to-top{bottom:calc(var(--inputs-min-height, 48px) + (2 * var(--padding-md)) + 31px) !important;}' +
    'body.sticky-atc-on shopify-chat{--shopify-agent-activator-offset:calc(var(--inputs-min-height, 48px) + (2 * var(--padding-md)) + 31px - 9px) !important;}' +
    '}';
  document.head.appendChild(style);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.backToTop = null;
    this.backToTopTrigger = null;
    this.handleScroll = null;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.backToTop = this.querySelector('[data-ref="sticky-back-to-top"]');
    this.backToTopTrigger = document.querySelector(BACK_TO_TOP_TRIGGER_SELECTOR);

    if (this.backToTop) {
      this.backToTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    ensureChatOffsetStyle();
    this.#displayStickyAddToCart();
    this.#displayBackToTop();

    this.handleScroll = () => {
      this.#displayStickyAddToCart();
      this.#displayBackToTop();
    };
    window.addEventListener('scroll', this.handleScroll);
  }

  disconnectedCallback() {
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
    document.body.classList.remove('sticky-atc-on');
  }

  #displayStickyAddToCart() {
    const active = !(isElementInViewport(this.form) || isElementInViewport(this.footer));

    this.dataset.active = active ? 'true' : 'false';
    this.classList.toggle('color-scheme-1', active);
    document.body.classList.toggle('sticky-atc-on', active);
  }

  // La fleche "retour en haut" n'apparait qu'une fois la section solidite atteinte.
  // Si la page n'a pas cette section (autres modeles de page produit), on conserve
  // le comportement d'origine : la fleche reste visible.
  #displayBackToTop() {
    if (!this.backToTop) return;

    if (!this.backToTopTrigger) {
      this.backToTop.dataset.revealed = 'true';
      return;
    }

    const reached = this.backToTopTrigger.getBoundingClientRect().top <= 0;
    this.backToTop.dataset.revealed = reached ? 'true' : 'false';
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
